<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15 vertical-center-box">적용 대상 목록</div>
        <w-check-obj-table-popup-button class="mr-r4" type="physical" :checked-obj-list="syslogRuleTargets" selected-managetype-id="NMS" @change-obj-list="changeObjList"
        :disabled="!selectedRule" />
      </div>
      <div class="vertical-center-box" align="right">
        <w-header-search-button @click="toggleSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :column-default="columnDefault" :data="syslogRuleTargets" :columns="syslogRuleTargetColumns"
    highlight-current-row :show-custom-header="true" :show-search-tool="showSearchTool">
    </el-table-wrapper>
  </div>
</template>

<script>
import { cloneDeep, isEmpty, isNil, difference, map } from 'lodash';
import { stringify } from 'querystring';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import syslogSettingAPI from '@/api/settings/log/syslog-settings';
import WCheckObjTablePopupButton from '@/components/button/CheckObjTablePopupButton';

export default {
  name: 'WSyslogRuleTargetTable',
  props: {
    selectedRule: {
      type: Object,
    },
  },
  components: {
    WCheckObjTablePopupButton,
  },
  data() {
    const syslogRuleTargetColumns = [
      {
        prop: 'objName',
        label: '장비명',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'ipaddress',
        label: 'IP주소',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'objCompanyName',
        label: '제조사',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'objProductId',
        label: '모델',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
    ];
    return {
      showSearchTool: false,
      syslogRuleTargets: [],
      originSyslogRuleTargets: [],
      syslogRuleTargetColumns,
      selectedRow: null,
      columnDefault,
    };
  },
  watch: {
    selectedRule: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value) && !isNil(value.syslogRuleId)) {
          this.loadData();
        } else {
          this.syslogRuleTargets = [];
        }
      },
    },
  },
  computed: {
    syslogRuleId() {
      return isEmpty(this.selectedRule) || isNil(this.selectedRule.syslogRuleId) ? null : this.selectedRule.syslogRuleId;
    },
  },
  methods: {
    /**
     * 정책 목록에서 선택한 Rule의 적용 대상 목록을 불러온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadData() {
      const params = {
        params: {
          syslogRuleId: this.selectedRule.syslogRuleId,
        },
      };
      syslogSettingAPI.getNetdeviceBySyslogTarget(params).then((response) => {
        this.syslogRuleTargets = cloneDeep(response.data.data);
        this.originSyslogRuleTargets = cloneDeep(response.data.data);
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '적용 대상 목록', false));
        throw new Error(e);
      });
    },
    getStringFormatter(row, column, value) {
      if (!isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    toggleSearchTool() {
      this.showSearchTool = !this.showSearchTool;
    },
    changeObjList(selectedObjList) {
      const querystring = stringify({
        syslogRuleId: this.syslogRuleId,
      });
      const checkedObjIds = map(selectedObjList, 'objId');
      const originCheckedObjIds = map(this.originSyslogRuleTargets, 'objId');

      const insertObjIds = difference(checkedObjIds, originCheckedObjIds);
      const deleteObjIds = difference(originCheckedObjIds, checkedObjIds);
      const params = {
        addObjs: insertObjIds,
        deleteObjs: deleteObjIds,
      };

      syslogSettingAPI.updateSyslogRuleTarget(querystring, params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.APPLY, '정책', response.data.success));
          this.loadData();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.APPLY, '정책', response.data.success));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.APPLY, '정책', false));
        throw new Error(e);
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/Syslog/components/SyslogRuleTargetTable.vue